  (function() {
    /* === Sort === */
    var sortSelect = document.getElementById('jfcSortSelect');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* === Client-side Search === */
    var searchInput = document.getElementById('jfcCollectionSearch');
    var grid = document.getElementById('jfcProductGrid');
    var noResults = document.getElementById('jfcNoResults');

    if (searchInput && grid) {
      var cards = grid.querySelectorAll('.jfc-pc');

      searchInput.addEventListener('input', function() {
        var query = this.value.toLowerCase().trim();
        var visibleCount = 0;

        cards.forEach(function(card) {
          var title = card.getAttribute('data-product-title') || '';
          if (query === '' || title.indexOf(query) !== -1) {
            card.style.display = '';
            visibleCount++;
          } else {
            card.style.display = 'none';
          }
        });

        if (noResults) {
          noResults.style.display = (visibleCount === 0 && query !== '') ? 'block' : 'none';
        }

        /* Hide pagination when filtering */
        var pagination = document.getElementById('jfcPagination');
        if (pagination) {
          pagination.style.display = query !== '' ? 'none' : '';
        }
      });
    }

    /* === View Toggle === */
    var viewBtns = document.querySelectorAll('.jfc-coll-toolbar__view-btn');
    viewBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var view = this.getAttribute('data-view');
        viewBtns.forEach(function(b) { b.classList.remove('jfc-active'); });
        this.classList.add('jfc-active');

        if (grid) {
          if (view === 'list') {
            grid.classList.add('jfc-list-view');
          } else {
            grid.classList.remove('jfc-list-view');
          }
        }
      });
    });

    /* Card entrance is now CSS-only (jfc-pc-in, animation-fill-mode:backwards, staggered
       via :nth-child in jfc-collection.css). The old IntersectionObserver here set an
       inline transition-delay that leaked onto the :hover transition and made the lift
       feel laggy — removed. Cards are always visible (base opacity:1), so no reveal JS. */
  })();
